import axios from "axios";

const ENDPOINT = "sensors";

export default {
  async retrieveSensors({ commit }) {
    try {
      const {
        data: {
          data: { sensors },
        },
      } = await axios.get(`${ENDPOINT}/`);
      commit("SET_SENSORS", sensors);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async retrieveSensor({ commit }, sensorId) {
    try {
      const {
        data: {
          data: { sensor },
        },
      } = await axios.get(`${ENDPOINT}/${sensorId}`);
      commit("SET_SENSOR_ITEM", sensor);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async retrieveSensorData(
    { commit },
    { macAddress, startDate = null, endDate = null }
  ) {
    try {
      const {
        data: {
          data: { sensorData },
        },
      } = await axios.post(`${ENDPOINT}/getSensorData/${macAddress}`, {
        startDate,
        endDate,
      });
      let temperatureData = [];
      let humidityData = [];
      let pressureData = [];
      let aqiData = [];
      let pm1Data = [];
      let pm2_5Data = [];
      let pm4Data = [];
      let pm10Data = [];
      let covData = [];
      let co2Data = [];

      sensorData.forEach((data) => {
        const dateTime = new Date(data.timestamp).getTime();
        temperatureData.push([dateTime, data.temperature]);
        humidityData.push([dateTime, data.humidity]);
        pressureData.push([dateTime, data.pressure]);
        aqiData.push([dateTime, data.aqi]);
        pm1Data.push([dateTime, data.pm1]);
        pm2_5Data.push([dateTime, data.pm2_5]);
        pm4Data.push([dateTime, data.pm4]);
        pm10Data.push([dateTime, data.pm10]);
        covData.push([dateTime, data.cov]);
        co2Data.push([dateTime, data.co2]);
      });
      commit("SET_TEMPERATURE_CHART", temperatureData);
      commit("SET_HUMIDITY_CHART", humidityData);
      commit("SET_PRESSURE_CHART", pressureData);
      commit("SET_AQI_CHART", aqiData);
      commit("SET_PM1_CHART", pm1Data);
      commit("SET_PM2_5_CHART", pm2_5Data);
      commit("SET_PM4_CHART", pm4Data);
      commit("SET_PM10_CHART", pm10Data);
      commit("SET_COV_CHART", covData);
      commit("SET_CO2_CHART", co2Data);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async retrieveUserSensors({ commit }, user) {
    try {
      const {
        data: {
          data: { sensors },
        },
      } = await axios.get(`${ENDPOINT}/userSensors/${user}`);
      commit("SET_USER_SENSORS", sensors);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async updateSensor({ commit }, updatedSensor) {
    try {
      const { nickname, provider, place, connectionType, owner } =
        updatedSensor;
      const {
        data: {
          data: { sensor },
        },
      } = await axios.put(`${ENDPOINT}/update/${updatedSensor.macAddress}`, {
        nickname,
        place,
        provider,
        connectionType,
        owner,
      });
      commit("SET_SENSOR", sensor);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },

  async assignSensorsToUser({ commit, getters }, { sensors, user }) {
    try {
      await axios.put(`${ENDPOINT}/assignSensorToUser/${user}`, {
        sensors,
      });
      const sensorsList = getters.getSensors.filter((sensor) =>
        sensors.includes(sensor.macAddress)
      );
      sensorsList.forEach((sensor) => {
        if (sensors.includes(sensor.macAddress)) {
          commit("SET_SENSOR", { ...sensor, owner: user });
        } else {
          commit("SET_SENSOR", { ...sensor, owner: null });
        }
      });
      commit("SET_USER_SENSORS", sensorsList);
      return true;
    } catch (err) {
      throw err.response.data || err.message;
    }
  },
};
